import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, type OnDestroy, type OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TermsOfServiceComponent } from '../../../features/terms-of-service/terms-of-service.component';
import { ConfigResourceService } from '../../../services/config-resource.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-terms-of-service-modal',
  templateUrl: './terms-of-service-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalComponent, TermsOfServiceComponent]
})
export class TermsOfServiceModalComponent implements OnInit, OnDestroy {
  headerText: string = '';
  closeText: string = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly dialogRef: MatDialogRef<TermsOfServiceComponent>,
    private readonly configService: ConfigResourceService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.headerText = this.configService.getProcessedResourceValue<string>('Spa_Site_TermsOfUse', 'Terms of Use');
            this.closeText = this.configService.getProcessedResourceValue<string>('DC5_Close_Text', 'Close');
            this.cdr.markForCheck();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
